module.exports = __webpack_public_path__ + "ce6f392fbbcb7616694e0340aac87ab4.png";